module.exports = __webpack_public_path__ + "static/media/evolution_57.56a7f56e.svg";